// 工具方法，需要的时候在开启，默认不开启，省流量
// export * from './date';
export * from './track';
// export * from './auth';
// export * from './download';

/**
 * 深度克隆简单对象
 * @param {*} obj
 */
export function cloneDeepPlainObject(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function getLZHost() {
  if (getLZHost.host) return getLZHost.host
  if (process.env.NODE_ENV === 'development') {
    return getLZHost.host = 'https://mobile-global-front.zmaxis.com'
  }
  return getLZHost.host = window.location.origin
}
